import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Skeleton from 'react-loading-skeleton';
import clss from 'classnames';
import { makeAddressInfo, makeNFTInfo } from '@/utils/link';
import Linker from '@/components/base/Linker';
import LazyImg from '@/components/base/LazyImg';
import styled from 'styled-components';
import { toNFTID } from '@/utils/string';
import { useMemo } from 'react';
import BigNumber from 'bignumber.js';
import Tooltip from '@/components/base/Tooltip';
import { DEFAULT } from '@/constants';
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
var NftCardStyled = styled.div.withConfig({
    displayName: "NFTCard__NftCardStyled",
    componentId: "sc-1cwo85e-0"
})([
    "transform:translateY(0) rotateZ(0deg);img{object-fit:cover;}&:hover{z-index:2;}.card-link{",
    " &:hover{box-shadow:0px 4px 32px rgba(0,0,0,0.08),0px 4px 64px rgba(0,0,0,0.08);}}.card-name{",
    "}.card-id{",
    " word-break:keep-all;}.card-desc{",
    "}"
], {
    "backgroundColor": "var(--color-box-bg)",
    "padding": "12px",
    "width": "328px",
    "borderWidth": "1px",
    "borderColor": "var(--color-card-border)",
    "borderRadius": "16px",
    "cursor": "pointer",
    "display": "block",
    "transitionProperty": "all",
    "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
    "transitionDuration": "500ms",
    "transformOrigin": "center"
}, {
    "fontSize": "20px",
    "color": "var(--color-text)",
    "fontWeight": "600",
    "lineHeight": "24px",
    "marginTop": "12px"
}, {
    "fontSize": "14px",
    "lineHeight": "17px",
    "marginTop": "8px",
    "marginBottom": "12px",
    "color": "var(--color-text-secondary)"
}, {
    "color": "var(--color-desc-text)",
    "fontSize": "14px",
    "lineHeight": "22px",
    "overflow": "hidden",
    "display": "-webkit-box",
    "WebkitBoxOrient": "vertical",
    "WebkitLineClamp": "3",
    "overflowWrap": "break-word"
});
var NFTCard = function(props) {
    var ref = props || {}, className = ref.className, Name = ref.Name, IDCount = ref.IDCount, Description = ref.Description, _BaseID = ref.BaseID, BaseID = _BaseID === void 0 ? 0 : _BaseID, Address = ref.Address, _simple = ref.simple, simple = _simple === void 0 ? false : _simple, _loading = ref.loading, loading = _loading === void 0 ? false : _loading, Definition = ref.Definition, Vault = ref.Vault, ID = ref.ID, _serie = ref.serie, serie = _serie === void 0 ? 0 : _serie, isId = ref.isId, ArtworkBaseUrl = ref.ArtworkBaseUrl, Hash = ref.Hash;
    /**
   * renderID
   * Definition
   * independence： ！Definition.sereis
   * combination： Definition.sereis instanceof Number
   * series： Definition.sereis instanceof Array  [{hash, name}]
   * Vault ID
   * independence： Vault = [ID] ID === BaseID serie = 0
   * combination： Vault = [[ID, count]] serie = ID - BaseID
   * series： Vault = [ID] serie = ID - BaseID
   */ var renderID = useMemo(function() {
        if (Vault) {
            var IDs = [];
            Vault.forEach(function(v) {
                var startId = _instanceof(v, Array) ? v[0] : v;
                var startSeries = new BigNumber(startId).minus(new BigNumber(BaseID)).toString();
                var count = _instanceof(v, Array) ? v[1] : 0;
                IDs.push(toNFTID(startSeries, startId, count));
            });
            return Vault.length === 1 && !_instanceof(Vault[0], Array) ? /*#__PURE__*/ _jsx("p", {
                className: "card-id line-clamp",
                children: IDs.join(', ')
            }) : /*#__PURE__*/ _jsx(Tooltip, {
                placement: "bottom",
                overlay: /*#__PURE__*/ _jsx("div", {
                    style: {
                        maxWidth: 530,
                        maxHeight: '200px',
                        overflowY: 'auto'
                    },
                    children: IDs.map(function(i, index) {
                        /*#__PURE__*/ return _jsxs("span", {
                            children: [
                                i,
                                index + 1 !== IDs.length && ',',
                                /*#__PURE__*/ _jsx("br", {})
                            ]
                        }, i);
                    })
                }),
                children: /*#__PURE__*/ _jsx("span", {
                    className: "card-id line-clamp",
                    children: IDs.join(', ')
                })
            });
        }
        if (Definition) {
            if ((Definition === null || Definition === void 0 ? void 0 : Definition.series) && IDCount) {
                return(/*#__PURE__*/ _jsx(Tooltip, {
                    placement: "bottom",
                    overlay: /*#__PURE__*/ _jsx("div", {
                        style: {
                            maxWidth: 530
                        },
                        children: toNFTID(0, BaseID, IDCount)
                    }),
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "card-id line-clamp",
                        children: toNFTID(0, BaseID, IDCount)
                    })
                }));
            }
            return(/*#__PURE__*/ _jsx("p", {
                className: "card-id line-clamp",
                children: toNFTID(serie, BaseID)
            }));
        }
        if (IDCount && IDCount > 1) {
            return(/*#__PURE__*/ _jsx(Tooltip, {
                placement: "bottom",
                overlay: /*#__PURE__*/ _jsx("div", {
                    style: {
                        maxWidth: 530
                    },
                    children: toNFTID(0, BaseID, IDCount)
                }),
                children: /*#__PURE__*/ _jsx("span", {
                    className: "card-id line-clamp",
                    children: toNFTID(0, BaseID, IDCount)
                })
            }));
        }
        return(/*#__PURE__*/ _jsx("p", {
            className: "card-id line-clamp",
            children: toNFTID(serie, ID || BaseID)
        }));
    }, [
        Definition,
        Vault,
        BaseID,
        IDCount,
        ID,
        serie
    ]);
    var renderSeriesImg = useMemo(function() {
        // series id show id img
        var singleSerieNFT = Vault && Vault.length === 1 && !_instanceof(Vault[0], Array);
        if (Definition && _instanceof(Definition === null || Definition === void 0 ? void 0 : Definition.series, Array) && Definition.series.length && !singleSerieNFT) {
            // Definition
            var childLenOver = Definition.series.length - 3 || 0;
            return(/*#__PURE__*/ _jsxs("div", {
                className: "ml-[10px] w-[64px]",
                children: [
                    (Definition === null || Definition === void 0 ? void 0 : Definition.series[0]) && /*#__PURE__*/ _jsx(LazyImg, {
                        className: "w-[64px] h-[64px] mb-[10px] rounded-[12px]",
                        url: ArtworkBaseUrl + (Definition === null || Definition === void 0 ? void 0 : Definition.series[0].hash),
                        alt: "nft",
                        defaultUrl: DEFAULT.NFT_ICON
                    }),
                    (Definition === null || Definition === void 0 ? void 0 : Definition.series[1]) && /*#__PURE__*/ _jsx(LazyImg, {
                        className: "w-[64px] h-[64px] mb-[10px] rounded-[12px]",
                        url: ArtworkBaseUrl + (Definition === null || Definition === void 0 ? void 0 : Definition.series[1].hash),
                        alt: "nft",
                        defaultUrl: DEFAULT.NFT_ICON
                    }),
                    (Definition === null || Definition === void 0 ? void 0 : Definition.series[2]) && /*#__PURE__*/ _jsxs("div", {
                        className: "relative rounded-[12px] overflow-hidden",
                        children: [
                            /*#__PURE__*/ _jsx(LazyImg, {
                                className: "w-[64px] h-[64px]",
                                url: ArtworkBaseUrl + (Definition === null || Definition === void 0 ? void 0 : Definition.series[2].hash),
                                alt: "nft",
                                defaultUrl: DEFAULT.NFT_ICON
                            }),
                            !!childLenOver && /*#__PURE__*/ _jsx("div", {
                                className: "absolute top-0 left-0 bg-[#000000] bg-opacity-60 w-full h-full flex items-center justify-center",
                                children: /*#__PURE__*/ _jsxs("span", {
                                    className: "text-[#ffffff] text-[14px] font-[600]",
                                    children: [
                                        "+",
                                        childLenOver
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }));
        }
        return '';
    }, [
        Definition,
        Vault,
        ArtworkBaseUrl
    ]);
    var linkUrl = isId ? makeNFTInfo(serie || 0, Vault && !_instanceof(Vault[0], Array) ? Vault[0] : ID || BaseID) : makeAddressInfo(Address || '');
    return(/*#__PURE__*/ _jsx(NftCardStyled, {
        children: /*#__PURE__*/ _jsxs(Linker, {
            href: linkUrl,
            className: clss(simple ? 'h-[305px]' : 'h-[380px]', 'card-link', className),
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "w-full flex",
                    children: [
                        /*#__PURE__*/ _jsx(LazyImg, {
                            className: clss('h-[212px] rounded-[12px]', renderSeriesImg ? 'w-[230px]' : 'w-full'),
                            url: ArtworkBaseUrl + Hash,
                            alt: "nft",
                            defaultUrl: DEFAULT.NFT_ICON
                        }),
                        renderSeriesImg
                    ]
                }),
                simple ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: loading ? /*#__PURE__*/ _jsxs("div", {
                        className: "mt-[16px] ml-[12px]",
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton, {
                                height: 24,
                                width: "124px"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                height: 17,
                                width: "64px"
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs("div", {
                        className: "mt-[16px] ml-[12px]",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "card-name line-clamp",
                                children: Name
                            }),
                            renderID
                        ]
                    })
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "mt-[16px] ml-[12px]",
                    children: loading ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Skeleton, {
                                height: 24,
                                width: "124px"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                height: 17,
                                width: "64px"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                height: 14,
                                width: "292px"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                height: 14,
                                width: "292px"
                            }),
                            /*#__PURE__*/ _jsx(Skeleton, {
                                height: 14,
                                width: "64px"
                            })
                        ]
                    }) : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "card-name line-clamp",
                                children: Name
                            }),
                            renderID,
                            /*#__PURE__*/ _jsx("p", {
                                className: "card-desc",
                                children: Description || '--'
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
export default NFTCard;
